import { useState, useEffect, useRef } from 'react';
import Bredcrum from '../../components/bredcrum';
import { Tablescom } from '../../components/tablescomp';
import { manufacturerServices } from '../../services/manufacturerServices';
import { Titlebar, Searchbox, Confirmdelete, Shipmentstatus,Orderstatus } from '../../components/fieldsComp';
import { BrowserRouter, Routes, Route, useNavigate } from "react-router";
import { Dialog } from 'primereact/dialog';
import { TabMenu } from 'primereact/tabmenu';
import { localurl } from '../../constant';
import { Toast } from "primereact/toast";
import { exportToExcel } from '../../helpers/exporttoexcel';
import { shipmentServices } from '../../services/shipmentServices';
import { Timeline } from 'primereact/timeline';
import { warehouseService } from '../../services/warehouseService';
import { Button } from 'bootstrap';
import {Shopifyordersfetch,Shopifywarehousesfetch} from '../../components/artifacts/shopifycomp'; 
import {useStock} from '../../contexts/stockContexts'; 

const Warehouse = () => {

  const navigate = useNavigate();
  const [users, setUsers] = useState([]);
  const [results, setResults] = useState([]);
  const [userloaded, setUserloaded] = useState(false);
  const [activeIndex, setActiveIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [popvisible, setPopvisible] = useState(false);
  const [deleleteid, setDeleleteid] = useState(false);
  const [viewmanufacturer, setViewmanufacturer] = useState([]);
  const [viewvisible, setViewvisible] = useState(false);
  const toast = useRef(null);
  const [quickFilterText, setQuickFilterText] = useState('');
  const [totalRows, setTotalRows] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(10); //  dynamic page size
  const [viewdata, setViewdata] = useState([]);
  const [statusset, setStatusset] = useState('all');
  const {warehouses} = useStock();
    

 
  function handleStockFilter(status) {
    setStatusset(status);
  }

  useEffect(() => {
    // getshipment(1, '25');
    getwarehouse(1, 25)
  }, [statusset])


  // useEffect(() => {
  //   getwarehouse(currentPage, pageSize);
  // }, );

  // useEffect(() => {
  //   getwarehouse(getColDefs(currentPage, pageSize));
  // }, [currentPage, pageSize, viewdata]);

  const handleNext = () => {
    if (currentPage < Math.ceil(totalRows / pageSize)) {
      setCurrentPage(currentPage + 1);
    }
    getwarehouse(currentPage, pageSize );
  };

  const handlePrevious = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
     getwarehouse(currentPage, pageSize);
  };

  const deletewarehouse = (id) => {
    setPopvisible(true);
    setDeleleteid(id);
  }

  const getColDefs = (currentPage, pageSize) => [
    {
      headerName: "SR NO", width: 100,
      valueGetter: (params) => {
        return ((currentPage - 1) * pageSize) + params.node.rowIndex + 1;
      },
    },
    { headerName: "Warehouse Name", field: "name",tooltipField:"name"},
    { headerName: "Address", field: "address" },
    {
      headerName: "Email", field: "email",
    },
    {
      headerName: "Contact Person", field: "contact_person",
    },
    {
      headerName: "Phone Number", field: "phone"     
    },
    { headerName: "Warehouse Code", field: "warehouse_code",tooltipField:"warehouse_code" },
    {
      headerName: "City", field: "city"},
    {
      headerName: "State", field: "state"},
    {
      headerName: "Action",
      cellRenderer: (params) => (
        <>
          <button
            className="btn btn-xs btn-primary"
            onClick={() => editredirect(params.data.id, params.data)}
          >
            <i className="icon icon-note"></i>
          </button>
          &nbsp;
          <button
          className="btn btn-danger btn-xs"
          onClick={() => deletewarehousedata(params.data.id)}
        >
          <i className="icon icon-trash"></i>
        </button>
          &nbsp;
          <button
            className="btn btn-success btn-xs"
            onClick={() => viewshipmentdata(params.data)}
          >
            <i className="icon icon-eye"></i>
          </button>
        </>
      ),
    },
  ];

  const [colDefs, setColDefs] = useState(getColDefs(1, 5));

  const editredirect = (id, Data) => {
    navigate(`/warehouses/edit/${id}`, { state: { Warehouse: Data } });
  }

  const viewshipmentdata = (Data) => {
    setViewdata(Data);
    setViewvisible(true);
  }

  useEffect(() => {
    // setColDefs(getColDefs(currentPage, pageSize));
    getwarehouse(currentPage, pageSize, quickFilterText);
  }, []);

  const getwarehouse = (page, pageSize, quickFilterText= null) => {
    setUserloaded(true);
    warehouseService.getWarehouseData(page, pageSize, quickFilterText ).then((response) => {
      if (response.status == 200) {
        setResults(response.data.data.data);
        // setTotalRows(response.data.total);
        setCurrentPage(response.data.current_page);
        setTotalRows(response.data.total);
        console.log("The results data: ", results);
        setUserloaded(false);
      } else {
        setResults([]);
        setUserloaded(false);
      }
    }).catch((error) => {
      setResults([]);
      setUserloaded(false);
    });
  }

  const addproductnavigate = () => {
    // navigate.  
    navigate('/warehouses/add');
  }

  const deletewarehousedata = (deletedId) => {
    if (deletedId) {
      warehouseService.deletewarehouse(deletedId).then((response) => {
        if (response.status == 200) {
         
          setDeleleteid(false);
          toast.current.show({ severity: 'success', summary: 'Sale', detail: 'Warehouse deleted successfully' });
          getwarehouse(currentPage, pageSize);
           setPopvisible(false);
        }
      }).catch((error) => {
          setPopvisible(false);
      });
    }

  }

  const onPaginationChanged = (params) => {
    const gridApi = params.api;
    const newPage = gridApi.paginationGetCurrentPage() + 1;
    if (newPage !== currentPage) {
      setCurrentPage(newPage);
    }
  };

  const handlePageSizeChange = (e) => {
    const newSize = parseInt(e.target.value);
    setPageSize(newSize);
    setCurrentPage(1);           // reset to page 1
    getwarehouse(1, newSize);       // reload with new size
  };

  const canceldiag = () => {
    setPopvisible(false);
  }

  const handleExport = () => {
    exportToExcel({ data: results, filename: 'shipment' });
  }

  const events = ['2020', '2021', '2022', '2023'];

  return (
    <>
      <Toast ref={toast} />
      <Bredcrum title={'Warehouse Overview'} divider={false} />
      <Confirmdelete popvisible={popvisible} deletefun={deletewarehousedata} cancel={canceldiag} title="Freight" />


      <Dialog
        header="Shipment Data View"
        visible={viewvisible}
        style={{ width: '60vw' }}
        onHide={() => setViewvisible(false)}
        // footer={footerContent}
        modal
        className="p-fluid"
      >
        <div className="card-body">
          <div className="container mt-4">
            <div className="row" >
              <div class="row mb-3">
                <div class="col-md-6">
                  <label for="freight_provider_id" class="form-label">Warehouse Name</label>
                  <input type="text" value={viewdata.name} readOnly class="form-control"
                    id="warehouse_name" name="shipment_reference" placeholder="Enter shipment reference" />
                </div>
                <div class="col-md-6">
                  <label for="shipment_reference" class="form-label">Address</label>
                  <input type="text" value={viewdata.address} readOnly class="form-control"
                    id="warehouse_address" name="shipment_reference" placeholder="Enter shipment reference" />
                </div>

              </div>

              <div class="row mb-3">
                <div class="col-md-6">
                  <label for="origin" class="form-label">City</label>
                  <input type="text" class="form-control"
                    id="origin" name="city" readOnly placeholder="Enter Origin" value={viewdata.city} />
                </div>

                <div class="col-md-6">
                  <label for="destination" class="form-label">Country</label>
                  <input type="text" class="form-control"
                    id="destination" name="country" placeholder="Enter Destination" value={viewdata.country} readOnly />
                </div>

              </div>

              <div class="row mb-3">
                <div class="col-md-6">
                  <label for="freight_cost" class="form-label">Contact Person </label>
                  <input type="text" placeholder="Enter Freight Cost" class="form-control" id="freight_cost"
                    name="contact_person" value={viewdata.contact_person} readOnly />
                </div>
                <div class="col-md-6">
                  <label for="tracking_number" class="form-label">Email</label>
                  <input type="text" placeholder="Enter Tracking Number" class="form-control" id="tracking_number"
                    name="email" readOnly value={viewdata.email} />
                </div>

              </div>

              <div class="row mb-3">
                <div class="col-md-6">
                  <label for="shipment_date" class="form-label">Phone</label>
                  <input type="text" placeholder="Enter Freight Cost" class="form-control" id="shipment_date"
                    name="phone" readOnly value={viewdata.phone} />
                </div>
                <div class="col-md-6">
                  <label for="status" class="form-label">Warehouse Code</label>
                  <input type="text" placeholder="Enter Freight Cost" class="form-control" id="shipment_date"
                    name="warehouse_code" readOnly value={viewdata.warehouse_code} />
                </div>
              </div>

            </div>

          </div>
        </div>
      </Dialog>

      {/* <Dialog visible={visible} position='top' modal style={{ width: '50rem' }} onHide={() => { if (!visible) return; setVisible(false); }}>
        <div className="container py-5">
          <div className="card shadow-lg rounded-4 p-4">
            <h2 className="mb-4 text-center text-primary">Excel Multiple Data Upload</h2>

            <div className="text-center mb-4">
              <a
                href={localurl + "/templates/component.xlsx"}
                download
                className="btn btn-outline-primary rounded-pill px-4"
                target="_blank"
                rel="noopener noreferrer"
              >
                Download Excel Template
              </a>
            </div>
            <div id="status" className="status mt-4 text-center text-success fw-medium"></div>
          </div>
        </div>

      </Dialog> */}

      <div class="row">
        <div className='col-md-12 mb-2 mt-2'>
          <div className='flex-box flex-between flex-align-item-center'>
            {/* <div className=''>
                         <button className='btn btn-primary rounded-pill custom-btn-color custom-btn-br-color ps-5 pe-5' onClick={() => navigate('/addshipment')}>Add Shipment</button> 
                         &nbsp;
                         &nbsp;
                         &nbsp; 
                  </div> */}
            {/* <div><Titlebar text={'Warehouses Listing'} /></div> */}
            <div>
               <button className="btn btn-primary rounded-pill custom-btn-color custom-btn-br-color ps-5 pe-5" onClick={() => addproductnavigate()}>Add Warehouse</button>
               <span><Shopifywarehousesfetch/></span>
            </div>
            <Searchbox
              value={quickFilterText}
              onChange={(e) => setQuickFilterText(e.target.value)}
            />
          </div>
        </div>



        <div className="col-md-12 mt-2 ">
          <div className='row'>
            <div className='col-md-9'>
   
            </div>

            <div className='col-md-3'>
              <div>
                <button class="export-btn form-control w-50 pull-right" onClick={() => handleExport()}>
                  <i className='fa fa-file-excel'></i> &nbsp;Export to Excel</button>
              </div>
            </div>
          </div>
          <div className='card'>
            <div className='card-body card-body-style'>
              {/* <Timeline value={events} layout="horizontal" align="top" content={(item) => item} /> */}
              <Tablescom rowdata={results} coldefs={colDefs} isloaded={userloaded}
                quickFilterText={quickFilterText} paginationPageSize={pageSize} onPaginationChanged={onPaginationChanged}
                totalRows={totalRows} currentPage={currentPage} pageSize={pageSize} handleNext={handleNext}
                handlePrevious={handlePrevious}
                handlePageSizeChange={handlePageSizeChange} />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Warehouse;